"use client";
import React, { useState } from "react";

import styles from "./LeadTheFutureLp.module.scss";
import MidLine from "@/SvgIcons/MidLine";
import LeadTheFutureDownArrow from "@/SvgIcons/LeadTheFutureDownArrow";
import clsx from "clsx";
import WhyChooseHealthcare from "@/components/organisms/WhyChooseHealthcare/WhyChooseHealthcare";

export default function LeadTheFutureLp({ LeadTheFutureComponent, programPageOverview = null }) {
  const [currentSelectedState, setCurrentSelectedState] = useState(LeadTheFutureComponent?.List[0]?.Heading);
  const [currentSelectedStateIndex, setCurrentSelectedStateIndex] = useState(0);
  const {
    isEnabledOnLandingPage = false,
    Title = "",
    Subtitle = "",
    Logos = [],
    rightImagelist = [],
  } = programPageOverview || {};

    const shouldShowWhyChoose =
      isEnabledOnLandingPage === true &&
      (
        Boolean(Title) ||
        Boolean(Subtitle) ||
        (Logos?.length ?? 0) > 0 ||
        (rightImagelist?.length ?? 0) > 0
      );

  const isMobile = () => {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
  };

  const onClickHandler = (key, index) => {
    if (key === currentSelectedState && isMobile()) {
      setCurrentSelectedState("");
      setCurrentSelectedStateIndex(0);
    } else {
      setCurrentSelectedState(key);
      setCurrentSelectedStateIndex(index);
    }
  };

  const formatText = (text) => {
    const match = text.match(/^(\d+)(.*)/);
    if (!match) return <>{text}</>;

    return (
      <>
        <span className="lining-nums">{match[1]}</span>
        {match[2]}
      </>
    );
  };

  return (
    <div className={styles.leadTheFutureContainer} id="program_overview">
      {shouldShowWhyChoose && <WhyChooseHealthcare key="why-choose" WhyChooseMbaHealthcare={programPageOverview} />}
      <div className={clsx(styles.leadTheFutureContainerInner,"lining-nums")}>
        <h2>{LeadTheFutureComponent?.Heading}</h2>
        <p>{LeadTheFutureComponent?.Subheading}</p>

        <div className={styles.dropdownHeadVertical}>
          <div className={styles.headingWrapper}>
            {LeadTheFutureComponent.List.map(({ Heading, HeadingImage, RightImage, information}, index )  => (
            <React.Fragment  key={Heading}>
              <div
                key={Heading}
                className={
                  currentSelectedState != Heading
                    ? styles.headingWrapperInner
                    : `${styles.headingWrapperInner} ${styles.headingWrapperInnerSelected}`
                }
              >
                <div
                  onClick={() => onClickHandler(Heading, index)}
                  key={Heading}
                  className={currentSelectedState == Heading ? styles.heading : styles.headingSelected}
                >
                  <div className={styles.logoHeadingContainer}>
                    <img src={HeadingImage?.data?.attributes?.url} alt="Amity Online" /> {formatText(Heading)}
                  </div>
                  <div
                    className={
                      currentSelectedState != Heading
                        ? styles.leadTheFutureDownArrowDown
                        : styles.leadTheFutureDownArrowDownInitital
                    }
                  >
                    <LeadTheFutureDownArrow
                      color={currentSelectedState == Heading ? "#fff" : "#1a325d"}
                    />{" "}
                  </div>
                </div>
                {currentSelectedState == Heading && (
                  <div className={styles.mWebContent} dangerouslySetInnerHTML={{ __html: information || "" }} />
                )}
              </div>
             </React.Fragment> 
            ))}
          </div>

          <div className={styles.midline}>
            <MidLine />
          </div>

          <div className={styles.rightContent} dangerouslySetInnerHTML={{ __html: LeadTheFutureComponent.List[currentSelectedStateIndex]?.information || "" }} />

          <div className={styles.imageEnd}>
            <img src={LeadTheFutureComponent.List[currentSelectedStateIndex].RightImage?.data?.attributes?.url} alt="Amity Online" />
          </div>
        </div>
      </div>
    </div>
  );
}
